'use client'

import { useEffect } from 'react'

export default function DynamicWatermark ({
  // watermarkText,
  watermarkTextColor,
  watermarkBackgroundColor,
  watermarkInterval,
  watermarkFontSize
}) {
  useEffect(() => {
    // function setFontSizeBasedOnDevice (defaultFontSize) {
    //   const size = defaultFontSize.split('px')[0]
    //   const largeDeviceBreakpoint = 1200 // px
    //   const mediumDeviceBreakpoint = 768 // px
    //   // Get screen width
    //   const screenWidth = window.innerWidth
    //   // Adjust font size based on screen size
    //   let calculatedFontSize
    //   if (screenWidth >= largeDeviceBreakpoint) {
    //     calculatedFontSize = size // Large device
    //   } else if (screenWidth >= mediumDeviceBreakpoint) {
    //     calculatedFontSize = size * 0.85// Medium device (85% of default)
    //   } else {
    //     calculatedFontSize = size * 0.5 // Small device (50% of default)
    //   }
    //   return Math.ceil(calculatedFontSize)
    // };

    async function getWatermarkText () {
      const response = await fetch('/api/watermark')
      const data = await response.json()
      return data.ip
    }

    function setFontSizeBasedOnDevice (defaultFontSize) {
      const minSize = parseFloat(defaultFontSize) // Convert "px" value to number
      const largeDeviceBreakpoint = 1200 // px
      const mediumDeviceBreakpoint = 768 // px

      // Get screen width, device pixel ratio, and zoom level
      const screenWidth = window.innerWidth
      const dpr = window.devicePixelRatio || 1 // Default to 1 if undefined
      const zoomLevel = window.innerWidth / document.documentElement.clientWidth // Estimate zoom level

      // Adjust font size based on screen size
      let calculatedFontSize = minSize // Start with the minimum size
      if (screenWidth >= largeDeviceBreakpoint) {
        calculatedFontSize = minSize * 1.25 // Large devices: Increase by 25%
      } else if (screenWidth >= mediumDeviceBreakpoint) {
        calculatedFontSize = minSize * 1.1 // Medium devices: Increase by 10%
      }

      // Adjust for high-DPI screens (scale down font size for high-resolution screens)
      calculatedFontSize = calculatedFontSize / dpr

      // Adjust for zoom level (increase font size if zoomed out)
      if (zoomLevel < 1) {
        calculatedFontSize *= (1 / zoomLevel) // Increase font size if zoomed out (below 100%)
      }

      // Ensure font size never goes below the minimum size
      return Math.ceil(Math.max(calculatedFontSize, minSize))
    }

    function destroyPageAndReload () {
      const videos = document.getElementsByTagName('video')
      for (const video of videos) {
        video.pause()
        video.removeAttribute('src')
        video.load()
        video.remove()
      }
      window.location.reload()
    }

    const addWatermark = (videoElement, watermarkText, textColor, backgroundColor, interval, fontSize) => {
      class Watermark {
        addOverlayOnPlayer (videoElement, watermarkText, textColor, backgroundColor, interval, fontSize) {
          function getRandomPosition (min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min)
          }

          if (['HLS-VIDEO', 'HTML-VIDEO', 'SHAKA-VIDEO'].indexOf(videoElement.tagName) === -1) {
            console.warn('Passed element is not a video tag, destroying all videos and reloading the page.')
            const videos = document.getElementsByTagName('video')
            for (const video of videos) {
              video.pause()
              video.removeAttribute('src')
              video.load()
              video.remove()
            }
            window.location.reload()
            return false
          }

          let watermarkDiv = null
          const defaultPosition = { top: '0px', left: '0px' } // Default position

          const createWatermark = () => {
            // const parentElement = videoElement.parentElement

            const videoRect = videoElement.getBoundingClientRect()

            if (watermarkDiv) {
              if (watermarkDiv.textContent !== watermarkText) {
                console.warn('Watermark text has changed, destroying all videos and reloading the page.')
                destroyPageAndReload()
                return false
              }
              watermarkDiv.remove()
            }

            // Convert fontSize to a number
            const fontSizeNumber = setFontSizeBasedOnDevice(fontSize)
            // Calculate padding based on font size (e.g., 50% of the font size)
            const padding = fontSizeNumber * 0.5 + 'px'

            watermarkDiv = document.createElement('div')
            watermarkDiv.style.padding = padding
            watermarkDiv.style.color = textColor
            watermarkDiv.style.fontSize = fontSizeNumber + 'px'
            watermarkDiv.style.backgroundColor = backgroundColor
            watermarkDiv.style.position = 'absolute'
            watermarkDiv.style.zIndex = 99 // changed from 99999 to avoid issue with ads overlay
            watermarkDiv.style.top = defaultPosition.top
            watermarkDiv.style.left = defaultPosition.left
            watermarkDiv.append(watermarkText)

            const mediaWrapper = document.getElementsByClassName('player-dynamic-watermark-wrapper')
            if (mediaWrapper && mediaWrapper.length > 0) {
              if (
                window.getComputedStyle(mediaWrapper[0]).display !== 'none'
              ) {
                mediaWrapper[0].appendChild(watermarkDiv)
              } else {
                console.warn('Media wrapper display is none or height and width is 0, destroying all videos and reloading the page.')
                destroyPageAndReload()
                return false
              }
            } else {
              // parentElement.append(watermarkDiv);
              // reload the page
              console.warn('Watermark parent element not found, destroying all videos and reloading the page.')
              destroyPageAndReload()
              return false
            }

            const watermarkWidth = watermarkDiv.offsetWidth
            const watermarkHeight = watermarkDiv.offsetHeight

            watermarkDiv.style.left = getRandomPosition(1, videoRect.width - watermarkWidth) + 'px'
            watermarkDiv.style.top = getRandomPosition(1, videoRect.height - watermarkHeight) + 'px'
            watermarkDiv.style.pointerEvents = 'none'
          }
          createWatermark()
          window.setInterval(() => {
            createWatermark()
          }, interval)

          // Reset position on reload
          window.addEventListener('load', () => {
            if (watermarkDiv) {
              watermarkDiv.style.top = defaultPosition.top
              watermarkDiv.style.left = defaultPosition.left
            }
          })

          window.addEventListener('resize', () => {
            createWatermark()
          })
        }
      }

      const watermark = new Watermark()
      watermark.addOverlayOnPlayer(videoElement, watermarkText, textColor, backgroundColor, interval, fontSize)
    }

    async function renderWatermark () {
      let videoElement = document.querySelector('hls-video')
      if (!videoElement) {
        videoElement = document.querySelector('html-video')
      }
      if (!videoElement) {
        videoElement = document.querySelector('shaka-video')
      }

      if (videoElement) {
        // read url query params and check for watermark params
        const url = new URL(window.location.href)
        let watermarkText = url.searchParams.get('watermark_text')
        if (!watermarkText) {
          // make a request to /api/watermark
          watermarkText = await getWatermarkText()
        }
        addWatermark(videoElement, watermarkText, watermarkTextColor, watermarkBackgroundColor, watermarkInterval, watermarkFontSize)
      }
    }

    renderWatermark()
  })

  return null
}
